export default __webpack_public_path__ + "static/media/icon_alert_gray.25930fcc.svg";